





































	import Vue from 'vue';
	import Component from 'vue-class-component';
	import ArticleTemplate from '@/components/maternite/template/ArticleTemplate.vue';

	const Props = Vue.extend({
		props: {
			moisgrossesse: {
				type: Number,
				default: 1
			},
			affichertous: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				nbreArticlesParLigne: 3
			};
		}
	});

	@Component({
        components: {
			ArticleTemplate
        }
    })
	export default class BienVivreMaGrossesse extends Props {
	}
